import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'assetStatus';

export class AssetStatus extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
